import {
  PAYMENTS_PLANS,
  CHECKOUT,
  SELECTED_PLAN,
  CURRENTPLAN,
  FINANCIAL_STATMENT_TRANSLATION_PLANS,
  CANCELSUBSCRIPTION,
  PAY_BY_PAYPAL,
  PAYPAL_SUCCESS,
  GET_EXCHANGE_RATE,
  GET_SAVE_CARDS,
  SAVE_NEW_CARD,
  DELETE_CARD,
  GET_FREE_PLAN
} from '../actions/payments'
import {
  RepositoryFactory
} from '../repositories/RepositoryFactory'
import {
  store
} from '../store/store'
const paymentsRepository = RepositoryFactory.get('payments')

const state = {
  paymentsplan: [],
  selectedPlan: {},
  currentplan: {},
  financialStatments_plans: [],
  saveCards: [],
  notifications: ''
}

const mutations = {
  'notifications_commit': (state, data) => {
    state.notifications = data
  },
  [PAYMENTS_PLANS]: (state, data) => {
    state.paymentsplan = data
  },
  [SELECTED_PLAN]: (state, data) => {
    state.selectedPlan = data
  },
  [CURRENTPLAN]: (state, data) => {
    state.currentplan = data
  },
  [FINANCIAL_STATMENT_TRANSLATION_PLANS]: (state, data) => {
    state.financialStatments_plans = data
  },
  [GET_SAVE_CARDS]: (state, data) => {
    state.saveCards = data
  }
}

const actions = {
  [PAYMENTS_PLANS]: async ({
    commit
  }) => {
    try {
      commit('ISLOADING', true)
      const result = await paymentsRepository.getPlans('FinancialAnalysis')
      commit(PAYMENTS_PLANS, result.data)
    } catch (error) {
      commit('NOTIFICATION', error.response.data)
    }
    commit('ISLOADING', false)
  },
  [CANCELSUBSCRIPTION]: async ({
    commit
  }) => {
    try {
      commit('ISLOADING', true)
      const result = await paymentsRepository.cancelSubscription()
      // commit(CANCELSUBSCRIPTION, result.data)
      commit('ISLOADING', false)
      return result.data
    } catch (error) {
      commit('NOTIFICATION', error.response.data)
      commit('ISLOADING', false)
    }
  },
  [CHECKOUT]: async ({
    commit
  }, data) => {
    try {
      commit('ISLOADING', true)
      let result = await paymentsRepository.checkout(data)
      if (!result.data.hasOwnProperty('error')) {
        console.log('make payment ', result.data)
        await store.dispatch('UPDATELOGGEDINUSER', result.data)
      }
      commit('ISLOADING', false)
      return result.data
    } catch (error) {
      console.log('inside error ', error)
      commit('NOTIFICATION', error.response)
      commit('ISLOADING', false)
      return error.data
    }
  },
  [CURRENTPLAN]: async ({
    commit
  }, data) => {
    try {
      // commit('ISLOADING', true)
      const result = await paymentsRepository.planByID(data)
      commit(CURRENTPLAN, result.data)
      commit('ISLOADING', false)
      return result
    } catch (error) {
      commit('NOTIFICATION', error.response.data)
      // commit('ISLOADING', false)
      return error
    }
  },
  [GET_SAVE_CARDS]: async ({
    commit
  }, data) => {
    try {
      commit('ISLOADING', true)
      const result = await paymentsRepository.getSavedCards()
      commit(GET_SAVE_CARDS, result.data)
      commit('ISLOADING', false)
      return result.data
    } catch (error) {
      commit('NOTIFICATION', error.response.data)
      commit('ISLOADING', false)
      return error
    }
  },
  [FINANCIAL_STATMENT_TRANSLATION_PLANS]: async ({
    commit
  }) => {
    try {
      commit('ISLOADING', true)
      const result = await paymentsRepository.getPlans('FinancialTranslation')
      commit(FINANCIAL_STATMENT_TRANSLATION_PLANS, result.data)
    } catch (error) {
      commit('NOTIFICATION', error.response.data)
    }
    commit('ISLOADING', false)
  },
  [PAY_BY_PAYPAL]: async ({
    commit
  }, data) => {
    try {
      commit('ISLOADING', true)
      const result = await paymentsRepository.payByPayPal(data)
      return result
      // commit(FINANCIAL_STATMENT_TRANSLATION_PLANS, result.data)
    } catch (error) {
      commit('NOTIFICATION', error.response.data)
    }
    commit('ISLOADING', false)
  },
  [PAYPAL_SUCCESS]: async ({
    commit
  }, data) => {
    try {
      // commit('ISLOADING', true)
      var esc = encodeURIComponent
      let query = Object.keys(data)
        .map(k => esc(k) + '=' + esc(data[k]))
        .join('&')
      // console.log('query', query)
      const result = await paymentsRepository.PayPalSuccess(query)
      if (!result.data.hasOwnProperty('error')) {
        console.log('make payment ', result.data)
        await store.dispatch('UPDATELOGGEDINUSER', result.data)
      }
      return result.data
      // commit(FINANCIAL_STATMENT_TRANSLATION_PLANS, result.data)
    } catch (error) {
      commit('NOTIFICATION', error.response.data)
    }
    // commit('ISLOADING', false)
  },
  [GET_EXCHANGE_RATE]: async ({coomit}, data) => {
    let origionalCurrency = data
    const result = await paymentsRepository.getExchangeRate(origionalCurrency)
    return result
  },
  [SAVE_NEW_CARD]: async ({commit}, payload) => {
    try {
      commit('ISLOADING', true)
      let result = await paymentsRepository.saveCard(payload)
      if (!result.data.hasOwnProperty('error')) {
        console.log('make payment ', result)
      }
      commit('ISLOADING', false)
      return result.data
    } catch (error) {
      console.log('inside error ', error)
      commit('NOTIFICATION', error.response)
      commit('ISLOADING', false)
      return error.data
    }
  },
  [DELETE_CARD]: async ({commit}, payload) => {
    try {
      commit('ISLOADING', true)
      let result = await paymentsRepository.deleteCard(payload)
      if (!result.data.hasOwnProperty('error')) {
        commit('NOTIFICATION', result.data.error)
        // console.log('make payment ', result)
      }
      commit('ISLOADING', false)
      return result.data
    } catch (error) {
      console.log('inside error ', error)
      commit('NOTIFICATION', error.response)
      commit('ISLOADING', false)
      return error.data
    }
  },
  [GET_FREE_PLAN]: async ({commit}) => {
    try {
      commit('ISLOADING', true)
      let result = await paymentsRepository.getFreePlan()
      if (!result.data.hasOwnProperty('error')) {
        await store.dispatch('UPDATELOGGEDINUSER', result.data)
      }
      commit('ISLOADING', false)
      return result.data
    } catch (error) {
      console.log('inside error ', error)
      commit('NOTIFICATION', error.response)
      commit('ISLOADING', false)
      return error.data
    }
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/modules/payments.js